import cl from 'classnames';
import * as React from 'react';
import st from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { Typography } from '../../../../DesignSystemV2/Typography';
import { FontSizeModeEnum } from '../types';
import {
  FontSizeElementVariants,
  FontSizeSwitcherElementProps,
} from './FontSizeSwitcherElement.types';

/**
 * FontSizeSwitcherElement with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Component-Styling)
 */

const ParagraphBullet = st.span.withConfig({
  componentId: 'FontSizeSwitcherElement_ParagraphBullet',
} as any)`
  margin-top: 20px;
`;

const Main = st.div.withConfig({
  componentId: 'FontSizeSwitcherElement_Main',
} as any)`
  color: ${colorsV2.black100};
  &.paragraph:not(:only-child) {
    margin-top: 20px;
  }
  &.paragraph-bullet {
    display: none;
  }

  .element-type-${FontSizeElementVariants.H1} {
    font-weight: bold;
    margin-bottom: 16px;
  }
  .element-type-${FontSizeElementVariants.H2} {
    font-weight: 600;
    margin-bottom: 16px
  }
  .element-type-${FontSizeElementVariants.PARAGRAPH_BULLET} {
    font-size: 10px;
    display: none;
    margin-top: 32px;
  }

  .font-size-${FontSizeModeEnum.DEFAULT} {
    font-size: 16px;
    &.element-type-${FontSizeElementVariants.H1} {
      font-size: 24px;
    }
    &.element-type-${FontSizeElementVariants.H2} {
      font-size: 16px;
    }
    &.element-type-${FontSizeElementVariants.PARAGRAPH_BULLET} {
      font-size: 10px;
    }
  }


  .font-size-${FontSizeModeEnum.LARGE} {
    font-size: 24px;
    &.element-type-${FontSizeElementVariants.H1} {
      font-size: 32px;
    }
    &.element-type-${FontSizeElementVariants.H2} {
      font-size: 24px;
    }
    &.element-type-${FontSizeElementVariants.PARAGRAPH_BULLET} {
      font-size: 18px;
    }
  }

  .font-size-${FontSizeModeEnum.EXTRA_LARGE} {
    font-size: 32px;
    &.element-type-${FontSizeElementVariants.H1} {
      font-size: 40px;
    }
    &.element-type-${FontSizeElementVariants.H2} {
      font-size: 32px;
    }
    &.element-type-${FontSizeElementVariants.PARAGRAPH_BULLET} {
      font-size: 26px;
    }
  }
`;

export const FontSizeSwitcherElementBase = ({
  children,
  attributes,
  className,
  element,
  fontSizeMode,
}: FontSizeSwitcherElementProps) => {
  return (
    <Main
      {...attributes}
      className={cl(className, `element-type-${element.type}`, {
        paragraph: element.type === FontSizeElementVariants.PARAGRAPH,
        'paragraph-bullet': element.type === FontSizeElementVariants.PARAGRAPH_BULLET,
      })}
    >
      <span className={cl(`font-size-${fontSizeMode}`, `element-type-${element.type}`)}>
        {element.type === FontSizeElementVariants.PARAGRAPH && (
          <ParagraphBullet contentEditable={false}>
            <Typography.Text variant="bold/24">
              {element.paragraphIndex && `${element.paragraphIndex}. `}
            </Typography.Text>
          </ParagraphBullet>
        )}
        {children}
      </span>
    </Main>
  );
};

/**
 * FontSizeSwitcheElementa
 */
export const FontSizeSwitcherElement = FontSizeSwitcherElementBase;
